import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Alert } from "reactstrap";
import { getTranslation, UserProfileSidebarLanguages } from "../language";

function ModalTeamAssignment({
  toggleTeamAssignment,
  modal,
  team,
  setTeam,
  teams,
  saveTeamAssignment,
  contactSelected,
  assignLoading,
  assignError,
  membersOfGroup,
}) {
  const stateLoadingGeneral = useSelector((state) => state.General.loading);
  const teamsLoading = useSelector(state => state.Teams.loading);
  const language = useSelector((state) => state.Group.language);

  const translate = (key) => getTranslation(UserProfileSidebarLanguages, language, key);

  // Set current team as default when modal opens
  useEffect(() => {
    if (modal && contactSelected?.teamTagId && teams && teams.length > 0) {
      setTeam(contactSelected.teamTagId);
    }
  }, [modal, contactSelected, teams, setTeam]);

  // Get agents of the selected team
  const getAgentsOfTeam = () => {
    if (!team || !membersOfGroup) return [];
    
    return membersOfGroup.filter(member => 
      member.role === "ROLE_PUBLISHER" && 
      (member.teamTagId === team || member.teamId === team)
    );
  };

  // Get selected team name
  const getSelectedTeamName = () => {
    if (!team || !teams) return "";
    const selectedTeam = teams.find(t => t.id === team);
    return selectedTeam ? selectedTeam.name : "";
  };

  const agentsOfTeam = getAgentsOfTeam();
  const selectedTeamName = getSelectedTeamName();

  return (
    <Modal
      isOpen={modal}
      centered
      className={stateLoadingGeneral ? "loadingLocked__modal__blur" : ""}
      toggle={toggleTeamAssignment}
    >
      <ModalHeader toggle={toggleTeamAssignment}>
        {translate("Assign to team")}
      </ModalHeader>
      <ModalBody>
        {assignError && (
          <Alert color="danger" className="mb-3">
            {assignError}
          </Alert>
        )}
        
        <FormGroup>
          <Label for="team-select">{translate("Select team")}</Label>
          <Input
            type="select"
            name="team"
            id="team-select"
            onChange={(e) => {
              setTeam(e.target.value);
            }}
            value={team}
            disabled={teamsLoading}
          >
            <option value="" hidden>
              {teamsLoading ? translate("Loading teams...") : translate("Choose a team")}
            </option>
            {teams && teams.length > 0 ? (
              teams.map((teamItem, key) => (
                <option key={key} value={teamItem.id}>
                  {teamItem.name} {contactSelected?.teamTagId === teamItem.id ? `(${translate("Current team")})` : ''}
                </option>
              ))
            ) : (
              !teamsLoading && (
                <option value="" disabled>
                  {translate("No teams available")}
                </option>
              )
            )}
          </Input>
        </FormGroup>

        {/* Show agents of selected team */}
        {team && selectedTeamName && (
          <FormGroup className="mt-3 mb-0">
            <Label className="mb-2">
              {translate("Agents in team")} <strong>{selectedTeamName}</strong>:
            </Label>
            <div className="border rounded p-1" style={{ backgroundColor: '#f8f9fa' }}>
              {agentsOfTeam.length > 0 ? (
                <div className="d-flex flex-wrap gap-2">
                  {agentsOfTeam.map((agent, key) => (
                    <div 
                      key={key} 
                      className="d-flex align-items-center p-2 border rounded"
                      style={{ backgroundColor: 'white' }}
                    >
                      <span className="mr-2">{agent.name}</span>
                      <div 
                        style={{
                          backgroundColor: agent.serviceStatus === 1 ? 'green' : agent.serviceStatus === 2 ? 'orange' : 'red',
                          width: '10px',
                          height: '10px',
                          borderRadius: '50px'
                        }}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-muted">
                  No hay agentes en este equipo
                </div>
              )}
            </div>
          </FormGroup>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          color="link"
          onClick={() => {
            toggleTeamAssignment();
          }}
          disabled={assignLoading}
        >
          {translate("Cancel")}
        </Button>
        <Button
          type="button"
          color="primary"
          onClick={() => {
            saveTeamAssignment();
          }}
          disabled={assignLoading || !team || teamsLoading || team === contactSelected?.teamTagId}
        >
          {assignLoading ? translate("Saving...") : translate("Save")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalTeamAssignment;
